import { createContext, useContext } from 'react';

/** Μια ενότητα όπως τη βλέπει το ευρετήριο του φύλλου. */
export interface SheetEntry {
  id: string;
  label: string;
  dirty: boolean;
  el: HTMLElement | null;
}

export interface SheetContextValue {
  /** Προσθήκη ή ενημέρωση (ίδιο id). Σταθερή συνάρτηση. */
  register: (entry: SheetEntry) => void;
  unregister: (id: string) => void;
}

export const SheetContext = createContext<SheetContextValue | null>(null);

/** null έξω από SettingsSheet: η ενότητα δουλεύει και μόνη της (π.χ. σε test), απλώς χωρίς ευρετήριο. */
export const useSheetContext = (): SheetContextValue | null => useContext(SheetContext);

/** Το id στο DOM: πρόθεμα, ώστε ένα σύντομο id («color») να μη συγκρούεται με άλλο στοιχείο της σελίδας. */
export const sectionDomId = (id: string): string => `settings-${id}`;
